const SavedDesignChecker = {
    init: function(design_id, user_id, callback) {
        Loader.saveForLater.checking({stack: true});

        SavedDesignChecker.checkSavedDesignExistence(design_id, user_id, function(response) {
            Loader.endloading(function() {
                var data = response;
                if (data.existing) {
                    // Show error message with the cart list involving selected.
                    SavedDesignChecker.render(data.carts);
                } else {
                    if (_.isFunction(callback)) {
                        callback()
                    }
                }
            }, {stack: false});
        }, function() {
            Loader.endloading(function() {
                UIkit.notification({
                    message: "Something went wrong while checking if design can be deleted",
                    status: "danger",
                    pos: 'top-right'
                });
            }, {stack: false});
        });
    },

    checkSavedDesignExistence: function(design_id, user_id, callback, errorHandler) {
        var url;
        
        if (typeof global_vars !== "undefined") {
            url = global_vars.prolook_host + "/users/"+ user_id +"/saved-designs/" + design_id;
        } else {
            url = window.origin + "/users/"+ user_id +"/saved-designs/" + design_id;
        }

        $.get(url, callback).fail(errorHandler);
    },

    render: function(carts) {
        var tmpl = _.template($("#list-of-carts-linked").html());

        $("#saved-design-checker .cart-list").html("");
        $("#saved-design-checker .cart-list").html(tmpl({
            host: window.origin,
            carts: carts
        }));
        
        UIkit.modal("#saved-design-checker").show();
    }
}